import script from "./QOrdersFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./QOrdersFilters.vue?vue&type=script&setup=true&lang=js"

import "./QOrdersFilters.vue?vue&type=style&index=0&id=3af47ace&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3af47ace"]])

export default __exports__